import React from 'react';

import './bikeclubmobile.scss';

const MobileClub = (props) => {
  return <div className="bike_club_mobile">{props.children}</div>;
};

export default MobileClub;
